import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useCallback, useEffect, useState, createContext, useContext, useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';
import { useNavigationContext } from './navigation-context';
import { jsx as _jsx } from "react/jsx-runtime";
var UTMSourceContext = /*#__PURE__*/createContext({
  utmSource: null,
  refCode: null,
  removeRefCode: function removeRefCode() {
    return null;
  },
  removeUtmSource: function removeUtmSource() {
    return null;
  }
});
var UTM_SOURCE_STORAGE_KEY = 'utm_source';
var utmSourceAtom = globalThis.jotaiAtomCache.get("/vercel/path0/libs/utils-common/src/context/utm-context.tsx/utmSourceAtom", atomWithStorage(UTM_SOURCE_STORAGE_KEY, null));

var UTMSourceProvider = function UTMSourceProvider(_ref) {
  var children = _ref.children;

  var _useAtom = useAtom(utmSourceAtom),
      _useAtom2 = _slicedToArray(_useAtom, 2),
      utmSource = _useAtom2[0],
      setUtmSource = _useAtom2[1];

  var _useState = useState(null),
      refCode = _useState[0],
      setRefCode = _useState[1];

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var query = router === null || router === void 0 ? void 0 : router['query'];
  var queryRefCode = query === null || query === void 0 ? void 0 : query.ref_code;
  var queryUtmSource = query === null || query === void 0 ? void 0 : query.utm_source;
  var events = router === null || router === void 0 ? void 0 : router.events;
  var isRouteReady = router === null || router === void 0 ? void 0 : router.isReady;
  var isQueryUTMSourceValid = useMemo(function () {
    return typeof queryUtmSource === 'string' && !!queryUtmSource;
  }, [queryUtmSource]);
  var saveUTMSource = useCallback(function () {
    if (!isQueryUTMSourceValid) return;
    if (queryUtmSource) setUtmSource(queryUtmSource);
  }, [isQueryUTMSourceValid, queryUtmSource, setUtmSource]);
  var saveReferralCode = useCallback(function () {
    var urlRefCode = queryRefCode && Array.isArray(queryRefCode) ? queryRefCode[0] : queryRefCode;
    var localstorageRefCode = window.localStorage.getItem('ref_code');

    if (urlRefCode) {
      window.localStorage.setItem('ref_code', urlRefCode);
      setRefCode(urlRefCode);
    } else if (localstorageRefCode) {
      setRefCode(localstorageRefCode);
    }
  }, [queryRefCode]);
  useEffect(function () {
    if (!events) return;
    events.on('routeChangeStart', saveUTMSource);
    return function () {
      events.off('routeChangeStart', saveUTMSource);
    };
  }, [events, saveUTMSource]);
  useEffect(function () {
    if (isRouteReady) {
      saveUTMSource();
      saveReferralCode();
    }
  }, [isRouteReady, saveUTMSource, saveReferralCode]);
  var removeRefCode = useCallback(function () {
    window.localStorage.removeItem('ref_code');
    setRefCode(null);
  }, []);
  var removeUtmSource = useCallback(function () {
    setUtmSource(RESET);
  }, [setUtmSource]);
  return /*#__PURE__*/_jsx(UTMSourceContext.Provider, {
    value: {
      utmSource: utmSource,
      refCode: refCode,
      removeRefCode: removeRefCode,
      removeUtmSource: removeUtmSource
    },
    children: children
  });
};

var useUTMSource = function useUTMSource() {
  var context = useContext(UTMSourceContext);
  if (!context) throw new Error('useUTMSource must be used within a UTMSourceContext');
  return useMemo(function () {
    return context;
  }, [context]);
};

export { UTMSourceProvider, useUTMSource };